<template>
    <div>
        <div class="card-spec">
            <div class="card-spec-name">{{ $t("reference") }}</div>
            <div class="card-spec-value">{{ file.resource.reference }}</div>
        </div>
        <div class="card-spec">
            <div class="card-spec-name">{{ $t("collection") }}</div>
            <div class="card-spec-value text-truncate">
                {{ file.resource.base_product.collection.name }}
            </div>
        </div>
        <div class="card-spec">
            <div class="card-spec-name">{{ $t("product") }}</div>
            <div class="card-spec-value text-truncate">
                {{ file.resource.base_product.name }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "ProductVariant",
  props: {
    file: Object
  }
};
</script>

<style scoped>
</style>
